import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectPaymentSettlements = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectPaymentSettlements, state => get(state, 'loading', null)
)

const selectLoadingPaymentSettlements = createSelector(
  selectPaymentSettlements, state => get(state, 'paymentSettlementsLoading', null)
)

const selectSuccess = createSelector(
  selectPaymentSettlements, state => get(state, 'paymentSettlementsList', [])
)

const selectColumns = createSelector(
  selectPaymentSettlements, state => get(state, 'columns', [])
)

const selectPages = createSelector(
  selectPaymentSettlements, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectPaymentSettlements, state => get(state, 'totalItems', 0)
)

const selectError = createSelector(
  selectPaymentSettlements, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectPaymentSettlements, state => get(state, 'dataFilters', [])
)

const selectDataFiltersError = createSelector(
  selectPaymentSettlements, state => get(state, 'dataFiltersError', null)
)

const selectPaymentSettlementsStatuses = createSelector(
  selectPaymentSettlements, state => get(state, 'paymentSettlementsStatuses', [])
)

const selectMessageInformation = createSelector(
  selectPaymentSettlements, state => get(state, 'messageInformation', null)
)

const selectCurrencies = createSelector(
  selectPaymentSettlements, state => get(state, 'currencies', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  LOADING_LIST: selectLoadingPaymentSettlements,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,

  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersError,

  PAYMENT_SETTLEMENTS_STATUSES: selectPaymentSettlementsStatuses,
  ADD_PAYMENT_SETTLEMENT_INFORMATION: selectMessageInformation,
  CURRENCIES: selectCurrencies
}
